import type { TherapistUpdateAdditionalLanguagesApiQuery } from "@/Modules/Models/Api/Therapist";

import { patch2 } from "./utils/FunctionalTherapyApi";

export async function updateAdditionalLanguages(
  languages: TherapistUpdateAdditionalLanguagesApiQuery[]
): Promise<TherapistUpdateAdditionalLanguagesApiQuery[]> {
  return patch2<TherapistUpdateAdditionalLanguagesApiQuery[], TherapistUpdateAdditionalLanguagesApiQuery[]>(
    "/v1.0/therapists/me/additional_languages",
    languages
  );
}
